import { InferValueTypes } from '~/src/store';

import * as actionCreators from './actions';
import { initialState, initPopup, TWidgetsData } from './initialState';

export const actionTypesWidgets = {
    INITIALIZED: '@widgets/INITIALIZED',
    SHOW_NOTIFY: '@widgets/SHOW_NOTIFY',
    SET_ROUTER_SCREENS: '@widgets/SET_ROUTER_SCREENS',
    SET_LOADER_SCREEN: '@widgets/SET_LOADER_SCREEN',
    RESET: '@widgets/RESET',
    SET_LOADING: '@widgets/SET_LOADING',
    OPEN_POPUP: '@widgets/OPEN_POPUP',
    CLOSE_POPUP: '@widgets/CLOSE_POPUP',
    CLOSE_LEASING_CONFIRM: '@widgets/CLOSE_LEASING_CONFIRM',
    CLOSE_LEASING: '@widgets/CLOSE_LEASING',
} as const;

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;

export const widgetsReducer = (state: TWidgetsData = initialState, action: TActions): TWidgetsData => {
    switch (action.type) {
        case actionTypesWidgets.INITIALIZED: {
            return {
                ...state,
                connectionItems: action.payload.connectionItems,
                connectedItems: action.payload.connectedItems,
                loading: false,
                initialized: true,
            };
        }
        case actionTypesWidgets.RESET: {
            return {
                ...action.payload,
            };
        }
        case actionTypesWidgets.SET_LOADING: {
            return {
                ...state,
                loading: action.payload,
            };
        }
        case actionTypesWidgets.OPEN_POPUP: {
            return {
                ...state,
                popupData: {
                    ...action.payload,
                    isOpen: true,
                },
            };
        }
        case actionTypesWidgets.CLOSE_POPUP: {
            return {
                ...state,
                popupData: initPopup,
            };
        }
        case actionTypesWidgets.SET_ROUTER_SCREENS: {
            return {
                ...state,
                connectedItems:{ ...state.connectedItems, ...action.payload },
            };
        }
        case actionTypesWidgets.SHOW_NOTIFY: {
            return {
                ...state,
                notify: action.payload,
            };
        }
        default: {
            const unknownAction: unknown = action;
            return state || unknownAction;
        }
    }
};
